import { bl_fi_mst_ecomsync_item_syncing_queue_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class FinancialEcomsyncItemSyncingQueueContainerModel extends BaseContainerModel {
  bl_fi_mst_ecomsync_item_syncing_queue: bl_fi_mst_ecomsync_item_syncing_queue_RowClass = new bl_fi_mst_ecomsync_item_syncing_queue_RowClass();
}

